import { IAnimationRenderer } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-animations/slide-transition/render/interface';
import { IAnimationUpdateParams, ITransitionHandlerOptions } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-animations/slide-transition/interface';

export class CommonRenderer implements IAnimationRenderer {
    private options: ITransitionHandlerOptions;
    constructor(options: ITransitionHandlerOptions) {
        this.options = options;
    }

    public beforeAnimation = () => {
        this.options.beforeAnimation?.();
    };

    public renderAnimationFrame = (params: IAnimationUpdateParams) => {
        this.options.renderAnimationFrame?.(params);
    };

    public afterAnimation = () => {
        this.options.afterAnimation?.();
    };
}
